import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://rhrmapi.up2dateinc.com/", 
  // example: http://13.234.xxx.xxx:5000/api/
});

export default axiosInstance;